class MetafieldVariant extends DummyElement {
  #observer;
  #variants;

  constructor() {
    super();
    this.#variants = window.variantMeta.find(
      ({ key }) => key === this.key
    )?.variants;
  }

  connectedCallback() {
    if (this.#variants?.length) {
      this.#observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === "attributes") {
            const variantId = parseInt(mutation.target.value);
            const variant = this.#variants.find(({ id }) => id === variantId);
            this.content = variant.value;
            if (variant.value) {
              document
                .querySelector(`metafield-variant-label[key=${this.key}]`)
                .classList.remove("hidden");
            } else {
              document
                .querySelector(`metafield-variant-label[key=${this.key}]`)
                .classList.add("hidden");
            }
          }
        });
      });
      this.#observer.observe(document.querySelector(".js-variant-id"), {
        attributes: true
      });
    }
  }
  disconnectedCallback() {}

  get key() {
    return this.getAttribute("key");
  }

  set content(content) {
    this.innerText = content;
  }
}

customElements.define("metafield-variant", MetafieldVariant);
